// Installs a one-time global fetch interceptor so that when any admin API
// call comes back 401 (session revoked, idle timeout, or just expired), the
// stale local session is cleared and the admin is dropped back to the
// storefront with the login modal ready to reopen — instead of every admin
// hook's own fetch() silently failing and leaving the dashboard stuck.
let installed = false;

export const installAdminSessionGuard = () => {
  if (installed) return;
  installed = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    if (response.status === 401) {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const hasAdminToken = Boolean(localStorage.getItem('adminToken'));

      if (url.includes('/api/admin/') && !url.includes('/api/admin/auth/login') && hasAdminToken) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminData');
        sessionStorage.setItem('adminSessionExpired', '1');
        if (window.location.hash === '#admin-dashboard') {
          window.location.href = window.location.origin + window.location.pathname;
        }
      }
    }

    return response;
  };
};
